module.exports = __webpack_public_path__ + "static/media/transport3.d3402266.jpeg";